import { FC, ReactNode, useState } from "react";
import { AuthContext } from "./AuthContext";

interface AuthProviderProps {
    initialToken?: string;
    children: ReactNode;
}

export const AuthProvider: FC<AuthProviderProps> = ({ children, initialToken }) => {
    const [token, setToken] = useState<string | null>(initialToken ?? null);

    return (
        <AuthContext.Provider value={{ token, setToken }}>
            {children}
        </AuthContext.Provider>
    );
};